import { InfoContainer, InfoLabel } from "./ErrorLabel.styles";
import Icon, { CheckOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

const ErrorLabel = ({ inputErrors, match, weak }) => {
	const [errors, setErrors] = useState({});

	useEffect(() => {
		if (errors) setErrors(inputErrors);
	}, [inputErrors]);

	const errorList = Object.values(errors);

	const arr = [
		"Mayor a 7 caracteres",
		"Un digito",
		"Una letra minúscula",
		"Una letra mayúscula",
		"Un símbolo",
	];

	const viñeta = () => (
		<svg
			width="4"
			height="4"
			viewBox="0 0 4 4"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="2" cy="2" r="2" fill="#787878" />
		</svg>
	);

	const Circle = (props) => <Icon component={viñeta} {...props} />;

	if (weak)
		return (
			<InfoContainer>
				<InfoLabel>
					{errorList[0] === "checked" ? (
						<div className="label__icon-container">
							<CheckOutlined
								style={{
									fontSize: 14,
									color: "#145AB4",
									marginRight: 8,
								}}
							/>
							{arr[0]}
						</div>
					) : (
						<div className="label__icon-container">
							<Circle
								style={{
									fontSize: 16,
									color: "#145AB4",
									marginRight: 8,
								}}
							/>
							<div>{arr[0]}</div>
						</div>
					)}
				</InfoLabel>
			</InfoContainer>
		);

	return (
		<>
			{errorList.length ? (
				<InfoContainer>
					{errorList.map((err, index) => (
						<InfoLabel key={index}>
							{err === "checked" ? (
								<div className="label__icon-container">
									<CheckOutlined
										style={{
											fontSize: 14,
											color: "#145AB4",
											marginRight: 8,
										}}
									/>
									{arr[index]}
								</div>
							) : (
								<div className="label__icon-container">
									<Circle
										style={{
											fontSize: 16,
											color: "#145AB4",
											marginRight: 8,
										}}
									/>
									{arr[index]}
								</div>
							)}
						</InfoLabel>
					))}
				</InfoContainer>
			) : (
				<div style={{ textAlign: "left" }}>
					{match ? match.must : ""}
				</div>
			)}
		</>
	);
};

ErrorLabel.defaultProps = {
	inputErrors: {},
};

ErrorLabel.propTypes = {
	inputErrors: PropTypes.object,
};

export default ErrorLabel;
